import { getISODay, parseISO } from "date-fns";

export type CafeHoursData = {
  date: string;
  closes: string | null;
  opens: string | null;
  timezone: string;
};

export class CafeHoursModel {
  date: Date;

  day: number;

  closes?: Date;

  opens?: Date;

  timezone: string;

  get isClosed(): boolean {
    return !this.closes || !this.opens;
  }

  constructor({ date, closes, opens, timezone }: CafeHoursData) {
    this.date = parseISO(date.split("T")[0]);
    this.timezone = timezone;

    this.day = getISODay(this.date) - 1;

    if (opens && closes) {
      this.closes = CafeHoursModel.getDateTime(closes);
      this.opens = CafeHoursModel.getDateTime(opens);
    }
  }

  static getDateTime(dateString: string | null): Date | undefined {
    if (!dateString) return undefined;

    return parseISO(dateString);
  }

  static getTimeNumber(
    date: Date | undefined,
    timezone: string,
  ): number | undefined {
    if (!date) return undefined;

    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).formatToParts(date);

    const hour = parts.find(({ type }) => type === "hour")?.value;
    const minute = parts.find(({ type }) => type === "minute")?.value;

    return hour && minute ? parseFloat(`${hour}.${minute}`) : undefined;
  }

  static formatTime(
    date: Date | undefined,
    timezone: string,
    locale = "en-US",
  ): string | undefined {
    if (!date) return undefined;

    return new Intl.DateTimeFormat(locale, {
      timeZone: timezone,
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  }

  static formatWeekday(
    date: Date,
    timezone: string,
    locale = "en-US",
    weekday: "long" | "short" = "long",
  ): string {
    return new Intl.DateTimeFormat(locale, {
      timeZone: timezone,
      weekday,
    }).format(date);
  }
}
